import { index, configure, hits } from 'instantsearch.js/es/widgets';
import { connectStats } from 'instantsearch.js/es/connectors';
import BaseComponent from 'scripts/BaseComponent.js';
import GlobalAutocompleteSearchInstance from '../autocomplete-search';

export default class AutocompleteSearchCollectionHits extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.name = 'AutocompleteSearchCollectionHits';

    this.refs = {
      container: '.js-searchCollectionHits',
    };

    this.dom = {
      $component: component,
      $container: this.$get(this.refs.container),
    };

    this.state = {
      isEmptyClass: 'is-empty',
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.addCollectionHits();
  }

  addCollectionHits() {
    const { dom } = this;

    const emptyCustomStats = connectStats(this.setEmptyStats.bind(this));

    GlobalAutocompleteSearchInstance.search.addWidgets([
      index({
        indexName: 'shopify_collections',
      })
        .addWidgets([
          configure({
            hitsPerPage: 4,
          }),
          hits({
            container: dom.$container,
            templates: {
              item: this.getCollectionHit.bind(this),
            },
            cssClasses: {
              list: [`${this.name}__list`],
              item: [`${this.name}__item`],
            },
          }),
          emptyCustomStats(),
        ]),
    ]);
  }

  setEmptyStats({ nbHits }) {
    const { dom, state } = this;

    if (nbHits === 0) {
      dom.$component.classList.add(state.isEmptyClass);
    } else {
      dom.$component.classList.remove(state.isEmptyClass);
    }
  }

  getCollectionHit(hit) {
    return `
      <article class="${this.name}__collection">
        <a
          class="${this.name}__link body"
          href="/collections/${hit.handle}"
        >
          ${hit.title}
        </a>
      </article>
    `;
  }
}
